import module from 'nominas/finiquitos/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export class NominasFiniquitosCompletadosComponent {
  view = 1
  data
  promise

  constructor (NominasFiniquitosCompletados) {
    this.NominasFiniquitosCompletados = NominasFiniquitosCompletados
  }

  $onInit () {
    this.promise = this.NominasFiniquitosCompletados.get()
      .then((response) => {
        this.data = orderBy(response.data, ['proyecto.nombre', 'colaborador.nombre_completo'])
        this.data.forEach((finiquito, indice) => finiquito.indice = indice)
      })
  }

  eliminar (data) {
    this.data.splice(this.data.indexOf(data), 1)
    this.data = [...this.data]
  }
}

module.component('nominasFiniquitosCompletados', {
  controller: NominasFiniquitosCompletadosComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/nominas/finiquitos/components/completados/component.js